export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./softgamings.vue?vue&type=template&id=36bf8807"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/softgamings.vue?vue&type=template&id=36bf8807
// module id = 46wp
// module chunks = 0